import React, { useEffect } from 'react'
import './OfflineCourse.css'
import MetaTag from '../Meta/MetaTag'

function OfflineCourse() {
    useEffect(()=>{
        window.scrollTo({
            top : 0,
            behavior : 'smooth'
        })
    },[])
    return (
        <section className='offline-section'>
            <MetaTag title={'Offline NEET Courses - Irodov Classes'} description={'Discover our offline NEET courses at Irodov Classes. Benefit from personalized attention and expert coaching to ace the NEET exam.'} keyword={'Offline NEET courses, NEET coaching offline, Irodov Classes offline, best offline NEET coaching'} />
            <div className='container'>
                <div className='bg'></div>
                <div className='offline-main-container'>
                    <div className='heading'>
                        <span>OFFLINE COURSES</span>
                    </div>
                    <div className='offline-container'>
                        <div className='up'>
                            <table>
                                <thead>
                                    <tr>
                                        <th>S.NO.</th>
                                        <th>CODE</th>
                                        <th>NAME OF COURSE</th>
                                        <th>DURATION</th>
                                        <th>FEES</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1.</td>
                                        <td>CBSE11P</td>
                                        <td>CBSE + PHYSICS EXPERIMENTS AND ACTIVITIES</td>
                                        <td>ONE YEAR</td>
                                        <td>Rs.35K</td>
                                    </tr>
                                    <tr>
                                        <td>2.</td>
                                        <td>CBSE 12P</td>
                                        <td>CBSE + PHYSICS EXPERIMENTS AND ACTIVITIES</td>
                                        <td>ONE YEAR</td>
                                        <td>Rs35K</td>
                                    </tr>
                                    <tr>
                                        <td>3.</td>
                                        <td>NEET11P</td>
                                        <td>CBSE + NEET+PHYSICS EXPERIMENTS AND ACTIVITIES</td>
                                        <td>ONE YEAR</td>
                                        <td>Rs60K</td>
                                    </tr>
                                    <tr>
                                        <td>4.</td>
                                        <td>NEET12P</td>
                                        <td>CBSE + PHYSICS EXPERIMENTS AND ACTIVITIES</td>
                                        <td>ONE YEAR</td>
                                        <td>Rs60K</td>
                                    </tr>
                                    <tr>
                                        <td>5.</td>
                                        <td>NEET13D</td>
                                        <td>DROPPER BATCH XI AND XII SYLLABUS FOR NEET + PHYSICS EXPERIMENTS AND ACTIVITIES TO UNDERSTAND PHYSICS CONCEPTS THOROUGHLY</td>
                                        <td>ONE YEAR</td>
                                        <td>Rs60K</td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                    </div>
                        <div className='down'>
                            <span>Note:-</span>
                            <p>1) Fee is payable in two equal  instalments. One instalment after the trial of three classes and other after two months from the date of registration.</p>
                            <p>2) For some reason if any student want to discontinue the offline classes within two months from the date of registration then 60%of the submitted fee will be refunded, thereafter no fee will be refunded.</p>
                        </div>
                </div>


            </div>

        </section>
    )
}

export default OfflineCourse
